import { gql } from '@apollo/client'

export const GET_CONTENT_REPORT = gql`
  query GetContentReport($courseId: ID!) {
    contentReport(courseId: $courseId) {
      id
      reason
      status
      courseId
      createdAt
    }
  }
`

export interface IContentReportData {
  contentReport: {
    id: string
    reason: string
    status: string
    courseId: string
    createdAt: string
  } | null
}
